<template>
  <div>
    <b-list-group>
      <transition-group name="bounce">
        <b-list-group-item 
          v-for="record in records"
          :key="record.id"
          class="flex-column align-items-start mb-2 main-column"
        >
          <div
            class="d-flex w-100 justify-content-between align-items-center reference"
          >
            <span 
              :class="'cursor-pointer font-weight-bold'"
            >ID: {{ record.id }}, {{ record.name_from_file }} ({{ record.unit_percent }}<template v-if="record.property && record.property.external_number">, {{ record.property.external_number }}</template>)</span>
            <div class="d-flex align-items-center">
                <!-- <i class="bx bxs-trash cursor-pointer mr-2" v-if="!record.properties.length" @click="toTrashDictionaryElement(record.id)"></i> -->
                <!-- <i class="bx bx-add-to-queue cursor-pointer mr-2" @click="addSubElement[record.id] = !addSubElement[record.id]"></i> -->
                <i class="bx bx-edit cursor-pointer mr-2" @click.stop="showEditDictionaryElementInput(record.id)"></i>
            </div>
          </div>
        </b-list-group-item>
      </transition-group>
    </b-list-group>
    <BdrOneCSidebar
      :isOpen.sync='isOpen'
      :editedItem.sync="editedItem"
      @updateItem="updateItem"
    ></BdrOneCSidebar>
  </div>
</template>

<script>
import BdrOneCSidebar from '@/components/bdrPage/BdrOneCSidebar';

const initialDictionaryElement = () => (
    {
      name_from_file: '',
      bdr_dictionary_id: '',
      unit_percent: '',
      property: {}
    }
);

export default {
  name: 'NestedRecords',
  props: {
    records: {
      type: Array,
      required: true
    },
  },
  components: {
    BdrOneCSidebar
  },
  data() {
    return {
      editedItem: {
        id: '',
        name_from_file: '',
        bdr_dictionary_id: '',
        unit_percent: '',
        property: {}
      },
      isOpen: false
    }
  },
  methods: {
    showEditDictionaryElementInput(record_id) {
      const record = this.records.find(record => record.id === record_id);

      this.editedItem = record === undefined ? initialDictionaryElement() : JSON.parse(JSON.stringify(record));
      this.isOpen = true;
    },
    updateItem(item) {
      const recordIndex = this.records.findIndex(record => record.id === item.id);

      if (recordIndex !== -1) {
        this.records[recordIndex] = JSON.parse(JSON.stringify(item));
      }
    },
    toTrashDictionaryElement(id) {
      // axios
      //   .delete(`${API_BDR_DICTIONARY}/${id}`)
      //   .then((data) => {
      //     this.dictionary = this.dictionary.filter(item => item.id !== id)
      // });
    },
  },  
}
</script>
